import { render, staticRenderFns } from "./html-editor.vue?vue&type=template&id=c8553d58&"
import script from "./html-editor.vue?vue&type=script&lang=js&"
export * from "./html-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8553d58')) {
      api.createRecord('c8553d58', component.options)
    } else {
      api.reload('c8553d58', component.options)
    }
    module.hot.accept("./html-editor.vue?vue&type=template&id=c8553d58&", function () {
      api.rerender('c8553d58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/html-editor.vue"
export default component.exports